import React from 'react';
import IconPanelContainer from "../Containers/IconPanelContainer";
import JobItem from "../../Atoms/Items/JobItem";
import FormInput from "../../Atoms/Templates/FormInput";

const JobsPanel = () => {
  const jobs = ['Diseñador UX', 'Diseñador gráfico', 'CTO', 'Taquero', 'Viene viene', 'CM', 'MC']
  return (
    <IconPanelContainer
      icon="briefcase"
      title="Cargos de trabajo"
    >
      <div className="s-cross-center nowrap s-mb-12px">
        <FormInput placeholder="Nombre del puesto" className="small s-mr-12px" />
        <button className="button small whitespace-nowrap">Crear puesto</button>
      </div>
      <div className="flex s-flex-gap-8px">
        {jobs.map(job => (
          <JobItem job={job}/>
        ))}
      </div>
    </IconPanelContainer>
  );
};

export default JobsPanel;
